import { Box, Drawer } from '@mui/material';
import Button from '../Button/Button';
import DrawerHeader from './components/DrawerHeader';

interface DrawerProps {
    open: boolean;
    onClose: () => void;
    title: string | React.ReactElement;
    children: React.ReactNode;
    icon?: React.ReactElement;
    loading?: boolean;
    onSubmit?: () => void;
    disabled?: boolean;
    styles?: { [key: string]: string };
    goBackTxt?: string;
    onCloseButton?: any;
}

function CdDrawer({
    open,
    onClose,
    onCloseButton,
    loading,
    children,
    onSubmit,
    goBackTxt,
    disabled,
    styles = {},
    ...drawerHeaderProp
}: DrawerProps) {
    return (
        <Drawer anchor="right" open={!!open} onClose={onClose}>
            <Box
                component="form"
                onSubmit={(e: any) => {
                    e.preventDefault();
                    if (onSubmit) onSubmit();
                }}
                className="drawer-container"
                sx={{ ...styles }}
            >
                <DrawerHeader onClose={onCloseButton || onClose} {...drawerHeaderProp} />
                <Box className="drawer-body">{children}</Box>
                <Box className="drawer-actions">
                    <Button onClick={onCloseButton || onClose} type="outlined">
                        {goBackTxt || 'Cancelar'}
                    </Button>
                    {onSubmit && (
                        <Button disabled={disabled} loading={loading}>
                            Guardar
                        </Button>
                    )}
                </Box>
            </Box>
        </Drawer>
    );
}

export default CdDrawer;
